<template>
  <div>
    <div class="flex justify-between p-4 overflow-auto">
      <div class="flex items-center">
        <div
          class="mx-4 text-lg cursor-pointer"
          @click="setDateToToday"
          :class="{'text-gray-800': ifDateIsToday, 'text-gray-500': !ifDateIsToday}"
        >1T</div>
        <div
          class="mx-4 text-lg cursor-pointer"
          @click="setDatePeriodTo7d"
          :class="{'text-gray-800': ifDatePeriodIs7d, 'text-gray-500': !ifDatePeriodIs7d}"
        >7T</div>
        <div
          class="mx-4 text-lg cursor-pointer"
          @click="setDatePeriodTo1M"
          :class="{'text-gray-800': ifDatePeriodIs1M, 'text-gray-500': !ifDatePeriodIs1M}"
        >1M</div>
        <div
          class="mx-4 text-lg cursor-pointer"
          @click="setDatePeriodTo3M"
          :class="{'text-gray-800': ifDatePeriodIs3M, 'text-gray-500': !ifDatePeriodIs3M}"
        >3M</div>
        <div
          class="mx-4 text-lg cursor-pointer"
          @click="setDatePeriodTo6M"
          :class="{'text-gray-800': ifDatePeriodIs6M, 'text-gray-500': !ifDatePeriodIs6M}"
        >6M</div>
      </div>

      <div class="py-2 px-4 shadow rounded flex items-center">
        <span>
          <flat-pickr
            :config="configStartDate"
            class="mr-2 text-gray-500 text-lg"
            v-model="dateFrom"
            @on-change="onStartChange"
          ></flat-pickr>
        </span>
        <span class="font-semibold text-gray-800">
          <font-awesome-icon icon="long-arrow-alt-right"></font-awesome-icon>
        </span>
        <span class="ml-4">
          <flat-pickr :config="configEndDate" class="mr-2 text-gray-500 text-lg" v-model="dateTo"></flat-pickr>
        </span>
      </div>
    </div>
    <slot v-bind:dateFrom="dateFrom" v-bind:dateTo="dateTo"></slot>
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/airbnb.css";
import { German } from "flatpickr/dist/l10n/de";
import dayjs from "dayjs";

export default {
  components: {
    flatPickr
  },

  data() {
    return {
      dateFrom: this.$route.query.dateFrom || dayjs().format("YYYY-MM-DD"),
      dateTo: this.$route.query.dateTo || dayjs().format("YYYY-MM-DD"),
      configStartDate: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d.m.Y",
        locale: German,
        altInputClass: "w-100px",
        maxDate: dayjs().format()
      },
      configEndDate: {
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d.m.Y",
        locale: German,
        minDate: null,
        maxDate: dayjs().format(),
        altInputClass: "w-100px"
      }
    };
  },

  computed: {
    ifDateIsToday() {
      return (
        this.dateFrom === dayjs().format("YYYY-MM-DD") &&
        this.dateTo === dayjs().format("YYYY-MM-DD")
      );
    },
    ifDatePeriodIs7d() {
      return (
        this.dateFrom ===
          dayjs()
            .subtract(6, "days")
            .format("YYYY-MM-DD") &&
        this.dateTo === dayjs().format("YYYY-MM-DD")
      );
    },
    ifDatePeriodIs1M() {
      return (
        this.dateFrom ===
          dayjs()
            .subtract(1, "month")
            .format("YYYY-MM-DD") &&
        this.dateTo === dayjs().format("YYYY-MM-DD")
      );
    },
    ifDatePeriodIs3M() {
      return (
        this.dateFrom ===
          dayjs()
            .subtract(3, "month")
            .format("YYYY-MM-DD") &&
        this.dateTo === dayjs().format("YYYY-MM-DD")
      );
    },
    ifDatePeriodIs6M() {
      return (
        this.dateFrom ===
          dayjs()
            .subtract(6, "month")
            .format("YYYY-MM-DD") &&
        this.dateTo === dayjs().format("YYYY-MM-DD")
      );
    }
  },

  methods: {
    onStartChange(selectedDates, dateStr) {
      this.$set(this.configEndDate, "minDate", dateStr);
    },

    setDateToToday() {
      this.interval = "hour";
      this.dateFrom = dayjs().format("YYYY-MM-DD");
      this.dateTo = dayjs().format("YYYY-MM-DD");
    },

    setDatePeriodTo7d() {
      this.interval = "day";
      this.dateFrom = dayjs()
        .subtract(6, "days")
        .format("YYYY-MM-DD");
      this.dateTo = dayjs().format("YYYY-MM-DD");
    },

    setDatePeriodTo1M() {
      this.interval = "day";
      this.dateFrom = dayjs()
        .subtract(1, "month")
        .format("YYYY-MM-DD");
      this.dateTo = dayjs().format("YYYY-MM-DD");
    },

    setDatePeriodTo3M() {
      this.interval = "month";
      this.dateFrom = dayjs()
        .subtract(3, "month")
        .format("YYYY-MM-DD");
      this.dateTo = dayjs().format("YYYY-MM-DD");
    },

    setDatePeriodTo6M() {
      this.interval = "month";
      this.dateFrom = dayjs()
        .subtract(6, "month")
        .format("YYYY-MM-DD");
      this.dateTo = dayjs().format("YYYY-MM-DD");
    }
  }
};
</script>
